import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient, getStoredAuth, setStoredAuth, clearStoredAuth } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => getStoredAuth());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = getStoredAuth();
    if (stored?.access_token) {
      apiClient
        .get("/auth/me")
        .then((resp) => {
          setAuth({ ...stored, user: resp.data });
          setStoredAuth({ ...stored, user: resp.data });
        })
        .catch(() => {
          clearStoredAuth();
          setAuth(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async ({ email, password, mfa_code }) => {
    const resp = await apiClient.post("/auth/login", { email, password, mfa_code });
    setStoredAuth(resp.data);
    setAuth(resp.data);
    return resp.data;
  }, []);

  const logout = useCallback(() => {
    clearStoredAuth();
    setAuth(null);
    window.location.href = "/login";
  }, []);

  const value = { auth, user: auth?.user || null, loading, login, logout, setAuth };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
